module.exports = __webpack_public_path__ + "static/media/Mincemeatsauce.6fb1ee09.png";